import React from "react";
import "../TermsConditions.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import { motion } from "framer-motion";

import {
    FaFileContract,
    FaCheckCircle,
    FaGlobe,
    FaCopyright,
    FaShieldAlt,
    FaUserCheck,
} from "react-icons/fa";

const terms = [
    {
        icon: <FaCheckCircle />,
        title: "Acceptance of Terms",
        content:
            "By accessing or using the BlueLotus Infrasafety Projects Private Limited website, products, or cybersecurity services, you acknowledge that you have read, understood, and agree to be legally bound by these Terms & Conditions. If you do not agree with any part of these terms, you should discontinue the use of our website and services immediately.",
    },
    {
        icon: <FaGlobe />,
        title: "Use of Our Website",
        content:
            "Our website is provided for informational and business purposes only. You agree to use this website in a lawful manner and not engage in activities that could damage, disrupt, overload, or compromise the security, availability, or functionality of our website, systems, or services.",
    },
    {
        icon: <FaCopyright />,
        title: "Intellectual Property Rights",
        content:
            "All website content including text, graphics, logos, icons, software, designs, documentation, and other intellectual property is owned by or licensed to BlueLotus Infrasafety Projects Private Limited. Unauthorized copying, modification, distribution, republication, or commercial use of any material is strictly prohibited without prior written permission.",
    },
    {
        icon: <FaShieldAlt />,
        title: "Cybersecurity Services",
        content:
            "BlueLotus Infrasafety Projects Private Limited provides professional cybersecurity consulting, implementation, managed security, cloud security, endpoint protection, vulnerability assessments, and related technology services. The scope of each engagement is governed by separate service agreements, quotations, or contracts agreed upon between both parties.",
    },
    {
        icon: <FaUserCheck />,
        title: "User Responsibilities",
        content:
            "Users are responsible for providing accurate information when contacting us or requesting services. You agree not to misuse our website, attempt unauthorized access to any systems, upload malicious software, or engage in any activity that violates applicable laws or compromises cybersecurity.",
    },
];

const TermsConditions = () => {
    return (
        <>
            <Header />

            <title>Terms - Conditions | BlueLotus Infrasafety Projects Private Limited</title>

            {/* HERO */}

            <section className="terms-hero">

                <div className="container">

                    <motion.div
                        className="terms-hero-content"
                        initial={{ opacity: 0, y: 40 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                    >

                        <span>

                            Terms of Service

                        </span>

                        <h1>

                            Terms & Conditions

                        </h1>

                        <p>

                            Please read these Terms & Conditions carefully before
                            accessing or using the website and cybersecurity services
                            provided by <strong>BlueLotus Infrasafety Projects Private Limited</strong>.
                            By using our website, you acknowledge and agree to comply
                            with these terms governing the use of our services.

                        </p>

                    </motion.div>

                </div>

            </section>

            {/* INTRO */}

            <section className="terms-intro">

                <div className="container">

                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                    >

                        <div className="terms-tag">

                            <FaFileContract />

                            Legal Information

                        </div>

                        <h2>

                            Commitment to Transparency & Trust

                        </h2>

                        <p>

                            These Terms & Conditions establish the legal relationship
                            between BlueLotus Infrasafety Projects Private Limited and
                            users of our website and cybersecurity services. They are
                            intended to ensure transparency, protect intellectual
                            property, define responsibilities, and promote the secure
                            and lawful use of our digital platforms and professional
                            cybersecurity solutions.

                        </p>

                    </motion.div>

                </div>

            </section>

            {/* TERMS */}

            <section className="terms-section">

                <div className="container">

                    {terms.map((item, index) => (

                        <motion.div
                            className="terms-card"
                            key={index}
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{
                                duration: 0.5,
                                delay: index * 0.15,
                            }}
                        >

                            <div className="terms-icon">

                                {item.icon}

                            </div>

                            <div className="terms-content">

                                <h3>

                                    {item.title}

                                </h3>

                                <p>

                                    {item.content}

                                </p>

                            </div>

                        </motion.div>

                    ))}

                </div>

            </section>

            {/* ADDITIONAL TERMS */}

            <section className="terms-extra">

                <div className="container">

                    {/* Confidentiality */}

                    <motion.div
                        className="extra-card"
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.7 }}
                    >

                        <div className="extra-icon">

                            <FaShieldAlt />

                        </div>

                        <div>

                            <h3>

                                Confidentiality

                            </h3>

                            <p>

                                BlueLotus Infrasafety Projects Private Limited respects
                                the confidentiality of all client information shared
                                during consultations, assessments, implementation,
                                support, and managed cybersecurity services. Any
                                confidential information exchanged between both parties
                                shall be handled responsibly and protected using
                                appropriate security controls unless disclosure is
                                required by applicable law.

                            </p>

                        </div>

                    </motion.div>

                    {/* Limitation of Liability */}

                    <motion.div
                        className="extra-card"
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{
                            duration: 0.7,
                            delay: 0.15,
                        }}
                    >

                        <div className="extra-icon">

                            <FaShieldAlt />

                        </div>

                        <div>

                            <h3>

                                Limitation of Liability

                            </h3>

                            <p>

                                While we strive to provide high-quality cybersecurity
                                solutions and professional services, no security solution
                                can guarantee complete protection against every cyber
                                threat. BlueLotus Infrasafety Projects Private Limited shall not be liable for indirect,
                                incidental, consequential, or special damages resulting
                                from the use of our website, products, or services,
                                except where liability cannot be excluded under
                                applicable law.

                            </p>

                        </div>

                    </motion.div>

                    {/* Third Party */}

                    <motion.div
                        className="extra-card"
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{
                            duration: 0.7,
                            delay: 0.25,
                        }}
                    >

                        <div className="extra-icon">

                            <FaGlobe />

                        </div>

                        <div>

                            <h3>

                                Third-Party Websites

                            </h3>

                            <p>

                                Our website may contain links to third-party websites,
                                software vendors, or external resources. These websites
                                are provided solely for informational purposes.
                                BlueLotus Infrasafety Projects Private Limited does not
                                control or endorse the content, availability, privacy
                                practices, or security of third-party websites and is
                                not responsible for any interactions with them.

                            </p>

                        </div>

                    </motion.div>

                    {/* Termination */}

                    <motion.div
                        className="extra-card"
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{
                            duration: 0.7,
                            delay: 0.35,
                        }}
                    >

                        <div className="extra-icon">

                            <FaUserCheck />

                        </div>

                        <div>

                            <h3>

                                Suspension & Termination

                            </h3>

                            <p>

                                We reserve the right to suspend or terminate access to
                                our website or services without prior notice if any user
                                violates these Terms & Conditions, engages in unlawful
                                activities, attempts unauthorized access, or performs
                                actions that threaten the security, integrity, or
                                availability of our systems or services.

                            </p>

                        </div>

                    </motion.div>

                    {/* Governing Law */}

                    <motion.div
                        className="extra-card"
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{
                            duration: 0.7,
                            delay: 0.45,
                        }}
                    >

                        <div className="extra-icon">

                            <FaFileContract />

                        </div>

                        <div>

                            <h3>

                                Governing Law

                            </h3>

                            <p>

                                These Terms & Conditions shall be governed and interpreted
                                in accordance with the laws of India. Any disputes arising
                                from the use of our website or services shall be subject
                                to the exclusive jurisdiction of the competent courts in
                                Odisha, India, unless otherwise agreed in writing.

                            </p>

                        </div>

                    </motion.div>

                    {/* Updates */}

                    <motion.div
                        className="extra-card"
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{
                            duration: 0.7,
                            delay: 0.55,
                        }}
                    >

                        <div className="extra-icon">

                            <FaFileContract />

                        </div>

                        <div>

                            <h3>

                                Changes to These Terms

                            </h3>

                            <p>

                                BlueLotus Infrasafety Projects Private Limited may update
                                these Terms & Conditions from time to time to reflect
                                changes in our business operations, legal obligations,
                                technologies, or cybersecurity practices. Updated terms
                                will become effective immediately upon publication on
                                this website. Continued use of our website or services
                                constitutes acceptance of the revised Terms &
                                Conditions.

                            </p>

                        </div>

                    </motion.div>

                </div>

            </section>

            <Footer />

        </>
    );
};

export default TermsConditions;